<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.freeze"
          @keydown.esc="dialog.freeze = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Freeze Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div 
                        class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in configHeaders" 
                            :key="index"
                            class="px-0"
                            @click="item.freeze = !item.freeze ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.freeze">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.freeze ? 'font-weight-bold' : ''"
                                :style="item.freeze ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Freeze
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.hide"
          @keydown.esc="dialog.hide = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Hide Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.hide = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in headers" 
                            :key="index"
                            class="px-0"
                            @click="item.hide = !item.hide ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.hide">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.hide ? 'font-weight-bold' : ''"
                                :style="item.hide ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Hide
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="750"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                {{ index_extend === '' ? 'Tambah Quota' : 'Perpanjang Layanan' }}
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider
                    name="Paket" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Paket
                    </div>

                    <v-autocomplete
                      v-on:keyup.enter="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Contoh. Bulanan per user"

                      :search-input.sync="autocomplete.package"
                      :loading="process.load"

                      hide-details
                      
                      :items="packages"
                      item-value="id"
                      item-text="name"
                      :item-color="set_color"

                      v-model="form.package_id"
                      :success="form.package_id !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px; width: 50%;">
                      <template v-slot:item="data">
                        <span
                          class="body-2 text-capitalize">
                          {{ data.item.name }}
                        </span>
                      </template>

                      <template v-slot:selection="data">
                        <span
                          class="body-2 text-capitalize">
                          {{ data.item.name }}
                        </span>
                      </template>
                      
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.package_id !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Quota" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Quota
                    </div>

                    <v-select
                      v-on:keyup.enter="save()"
                      
                      filled
                      rounded
                      dense

                      :disabled="index_extend !== ''"

                      :color="set_color"
                      placeholder="Contoh. 10"

                      hide-details

                      :items="[10, 20, 30, 40, 50, 100]"
                      :item-color="set_color"

                      v-model="form.quota"
                      :success="form.quota !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-3"
                      style="border-radius: 10px; width: 30%;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.quota !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-select>
                  </ValidationProvider>

                  <v-row>
                    <v-col
                      cols="12"
                      md="6">
                      <ValidationProvider
                        name="@Harga" 
                        rules="required" 
                        v-slot="{ errors, valid }">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>
                          @Harga
                        </div>

                        <v-currency-field
                          v-on:keyup.enter="save()"
                          
                          filled
                          rounded
                          dense

                          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                          type="number"
                          :min="0"

                          disabled

                          @focus="$event.target.select()"

                          :color="set_color"
                          placeholder="Contoh. 10.000"

                          hide-details

                          v-model="form.at_price"
                          :success="form.at_price !== '' && valid"
                          :error-messages="errors"
                          required
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>

                            <div v-if="form.at_price !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-currency-field>
                      </ValidationProvider>
                    </v-col>

                    <v-col
                      cols="12"
                      md="6">
                      <ValidationProvider
                        name="@Diskon" 
                        rules="required" 
                        v-slot="{ errors, valid }">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>
                          @Diskon
                        </div>

                        <v-currency-field
                          v-on:keyup.enter="save()"
                          
                          filled
                          rounded
                          dense

                          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                          type="number"
                          :min="0"

                          disabled

                          @focus="$event.target.select()"

                          :color="set_color"
                          placeholder="Contoh. 5.000"

                          hide-details

                          v-model="form.at_discount"
                          :success="form.at_discount !== '' && valid"
                          :error-messages="errors"
                          required
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>

                            <div v-if="form.at_discount !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-currency-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>

                  <v-simple-table
                    class="my-2"
                    style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                    <template v-slot:default>
                      <tbody>
                        <tr
                          style="opacity: 70%;">
                          <td style="border: none !important;">Total Harga (x{{ form.quota }})</td>
                          <td style="border: none !important;" class="text-right">{{ parseInt(form.price) | price }}</td>
                        </tr>

                        <tr
                          style="opacity: 70%;">
                          <td style="border: none !important;">Total Diskon (x{{ form.quota }})</td>
                          <td style="border: none !important;" class="text-right">{{ parseInt(form.discount) | price }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>

                  <v-row>
                    <v-col
                      cols="12"
                      md="6">
                      <ValidationProvider
                        name="Total" 
                        rules="required" 
                        v-slot="{ errors, valid }">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>
                          Total
                        </div>

                        <v-currency-field
                          v-on:keyup.enter="save()"
                          
                          filled
                          rounded
                          dense

                          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                          type="number"
                          :min="0"

                          disabled

                          @focus="$event.target.select()"

                          :color="set_color"
                          placeholder="Contoh. 20.000"

                          hide-details

                          v-model="form.total"
                          :success="form.total !== '' && valid"
                          :error-messages="errors"
                          required
                          class="mb-3"
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>

                            <div v-if="form.total !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-currency-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>

                  <ValidationProvider
                    name="Jumlah Bulan" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Jumlah Bulan
                    </div>

                    <v-text-field
                      v-on:keyup.enter="save()"
                      
                      filled
                      rounded
                      dense

                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      type="number"
                      min="0"

                      @focus="$event.target.select()"
                      @keyup="form.month = form.month === '' || parseInt(form.month) < 1 ? 1 : form.month;"
                      @blur="form.month = form.month === '' || parseInt(form.month) < 1 ? 1 : form.month;"

                      :color="set_color"
                      placeholder="Contoh. 10"

                      hide-details

                      v-model="form.month"
                      :success="form.month !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-3"
                      style="border-radius: 10px; width: 30%;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.month !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>

                  <v-row>
                    <v-col
                      cols="12"
                      md="6">
                      <div>
                        <div 
                          class="body-2 mb-2">
                          <span class="red--text">*</span>
                          Tanggal Mulai
                        </div>

                        <v-menu
                          ref="start"
                          min-width="290px"
                          max-width="290px"
                          transition="scale-transition"
                          offset-y
                          :nudge-right="40"
                          :close-on-content-click="false"
                          v-model="picker.start">
                          <template v-slot:activator="{ on, attrs }">
                            <ValidationProvider 
                              name="Tanggal Mulai" 
                              rules="required" 
                              v-slot="{ errors, valid }">
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                :disabled="index_extend !== ''"
                                readonly
                                filled
                                rounded
                                dense

                                :color="set_color"
                                placeholder="Contoh. 2023-12-01"

                                hide-details

                                clearable
                                @click:clear="form.start_date = ''; form.end_date = '';"

                                v-on="on"
                                v-bind="attrs"

                                v-model="form.start_date"
                                :success="form.start_date !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>

                                  <div v-if="form.start_date !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </template>

                          <v-date-picker 
                            :color="set_color"
                            v-model="form.start_date"
                            @input="picker.start = false; form.end_date = '';">
                          </v-date-picker>
                        </v-menu>
                      </div>
                    </v-col>

                    <v-col
                      cols="12"
                      md="6">
                      <div>
                        <div 
                          class="body-2 mb-2">
                          <span class="red--text">*</span>
                          Tanggal Selesai
                        </div>

                        <v-menu
                          ref="end"
                          min-width="290px"
                          max-width="290px"
                          transition="scale-transition"
                          offset-y
                          :nudge-right="40"
                          :close-on-content-click="false"
                          v-model="picker.end">
                          <template v-slot:activator="{ on, attrs }">
                            <ValidationProvider 
                              name="Tanggal Selesai" 
                              rules="required" 
                              v-slot="{ errors, valid }">
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                disabled
                                readonly
                                filled
                                rounded
                                dense

                                :color="set_color"
                                placeholder="Contoh. 2023-12-30"

                                hide-details

                                clearable
                                @click:clear="form.end_date = ''"

                                v-on="on"
                                v-bind="attrs"

                                v-model="form.end_date"
                                :success="form.end_date !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>

                                  <div v-if="form.end_date !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </template>

                          <v-date-picker 
                            :color="set_color"
                            :min="form.start_date"
                            v-model="form.end_date"
                            @input="picker.end = false">
                          </v-date-picker>
                        </v-menu>
                      </div>
                    </v-col>
                  </v-row>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center my-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <div
                class="body-2 line-text-second"
                style="width: 60%;">
                {{ index_extend === '' ? 'Tambahkan quota untuk Perusahaan' : 'Perpanjang layanan untuk Perusahaan' }} <strong>{{ detail.name }}</strong>
              </div>

              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.detail"
          @keydown.esc="dialog.detail = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Detail Invoice
              </div>

              <v-spacer/>

              <div
                class="body-2 primary--text mr-4">
                {{ detail_invoice.input_datetime | date }} - {{ detail_invoice.input_datetime | time }}
              </div>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.detail = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0">
              <v-row>
                <v-col
                  cols="12"
                  md="12">
                  <v-card
                    flat
                    color="#F9F9F9"
                    style="border: 1px solid #D8D8D8; border-radius: 10px;">
                    <div
                      class="d-flex align-center">
                      <div
                        style="border-right: 1px solid #D8D8D8; width: 40%;">
                        <v-card
                          flat
                          color="#EDEDED"
                          class="body-2 font-weight-bold pa-4"
                          style="opacity: 70%;">
                          No. Invoice
                        </v-card>

                        <v-divider
                          style="border-top: 1px solid #D8D8D8;"/>

                        <v-card
                          flat
                          color="#EDEDED"
                          class="body-2 font-weight-bold pa-4"
                          style="opacity: 70%;">
                          Perusahaan
                        </v-card>

                        <v-divider
                          style="border-top: 1px solid #D8D8D8;"/>

                        <v-card
                          flat
                          color="#EDEDED"
                          class="body-2 font-weight-bold pa-4"
                          style="opacity: 70%;">
                          Jatuh Tempo
                        </v-card>
                      </div>

                      <div
                        style="width: 60%;">
                        <v-card
                          flat
                          color="transparent"
                          class="body-2 pa-4"
                          style="opacity: 70%;">
                          {{ detail_invoice.code }}
                        </v-card>

                        <v-divider
                          style="border-top: 1px solid #D8D8D8;"/>

                        <v-card
                          flat
                          color="transparent"
                          class="body-2 pa-4 text-truncate"
                          style="opacity: 70%;">
                          {{ detail_invoice.company_name }}
                        </v-card>

                        <v-divider
                          style="border-top: 1px solid #D8D8D8;"/>

                        <v-card
                          flat
                          color="transparent"
                          class="body-2 pa-4"
                          style="opacity: 70%;">
                          {{ detail_invoice.due_date | date }}
                        </v-card>
                      </div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>

              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr
                      style="opacity: 70%;">
                      <td style="border: none !important;" class="pl-0">Paket</td>
                      <td style="border: none !important;" class="text-right pr-0">{{ detail_invoice.package_name }}</td>
                    </tr>

                    <tr
                      style="opacity: 70%;">
                      <td style="border: none !important;" class="pl-0">Quota</td>
                      <td style="border: none !important;" class="text-right pr-0">{{ detail_invoice.quota }}</td>
                    </tr>

                    <tr
                      style="opacity: 70%;">
                      <td style="border: none !important;" class="pl-0">Harga (@{{ (parseInt(detail_invoice.price) / parseInt(detail_invoice.quota)) | price }} x {{ detail_invoice.quota }}) </td>
                      <td style="border: none !important;" class="text-right pr-0">{{ detail_invoice.price | price }}</td>
                    </tr>

                    <tr
                      style="opacity: 70%;">
                      <td style="border: none !important;" class="pl-0">Diskon (@{{ (parseInt(detail_invoice.discount) / parseInt(detail_invoice.quota)) | price }} x {{ detail_invoice.quota }})</td>
                      <td style="border: none !important;" class="text-right red--text pr-0">- {{ detail_invoice.discount | price }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <div
                class="body-1 font-weight-bold text-right black--text"
                style="padding: 20px 4px;">
                {{ detail_invoice.total | price }}
              </div>

              <div v-if="message.error.length > 0"
                class="text-center my-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <div
                class="body-2 line-text-second"
                style="width: 60%;">
                <span v-if="detail_invoice.status === 'Belum Bayar'">
                  Konformasi pembayaran untuk Invoice <strong>{{ detail_invoice.code }}</strong>
                </span>

                <span v-if="detail_invoice.status === 'Terbayar'">
                  Invoice <strong>{{ detail_invoice.code }}</strong> telah di konfirmasi
                </span>
              </div>

              <v-spacer/>

              <v-btn v-if="detail_invoice.status === 'Belum Bayar'"
                @click="save_approved()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Sudah Bayar
              </v-btn>

              <v-btn v-if="detail_invoice.status === 'Terbayar'"
                @click="dialog.detail = false; fetch();"
                width="120"
                elevation="0"
                :color="set_color"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Lihat
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                @click="$router.go(-1)"
                flat
                color="transparent"
                style="width: 15%;">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="28"
                      style="opacity: 30%;">
                      <v-img
                        contain
                        alt="diskominfo"  
                        :src="require('@/assets/icon/back_arrow.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Perusahaan
                    </span>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <div v-if="Object.keys(detail).length > 0">
            <v-row
              class="pa-4 pr-1">
              <v-col 
                cols="12"
                class="py-0">
                <v-card 
                  flat
                  style="border-radius: 10px; border: 1px solid #E7E7E7;">
                  <v-card-text
                    class="px-6">
                    <v-row>
                      <v-col
                        cols="12"
                        md="2">
                        <v-card
                          flat
                          color="#EDEDED"
                          min-height="107"
                          class="text-h2 font-weight-bold d-flex align-center justify-center"
                          style="border: 1px solid #D8D8D8; border-radius: 10px; padding: 23px;">
                          <v-img
                            contain
                            width="55"
                            height="55"
                            alt="diskominfo"  
                            :src="detail.logo_image_url !== '' ? detail.logo_image_url : require('@/assets/logo/favicon.png')"
                            class="ma-auto cursor-pointer">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="20"
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-card>
                      </v-col>

                      <v-col
                        cols="12"
                        md="4">
                        <v-card
                          flat
                          color="#F9F9F9"
                          style="border: 1px solid #D8D8D8; border-radius: 10px;">
                          <div
                            class="d-flex align-center">
                            <div
                              style="border-right: 1px solid #D8D8D8; width: 40%;">
                              <v-card
                                flat
                                color="#EDEDED"
                                class="body-2 font-weight-bold pa-4"
                                style="opacity: 70%;">
                                Perusahaan
                              </v-card>

                              <v-divider
                                style="border-top: 1px solid #D8D8D8;"/>

                              <v-card
                                flat
                                color="#EDEDED"
                                class="body-2 font-weight-bold pa-4"
                                style="opacity: 70%;">
                                Status
                              </v-card>
                            </div>

                            <div
                              style="width: 60%;">
                              <v-card
                                flat
                                color="transparent"
                                class="body-2 pa-4 text-truncate"
                                style="opacity: 70%;">
                                {{ detail.name }}
                              </v-card>

                              <v-divider
                                style="border-top: 1px solid #D8D8D8;"/>

                              <v-card
                                flat
                                color="transparent"
                                class="body-2 pa-4"
                                style="opacity: 70%;">
                                {{ !detail.is_active_bool ? 'Tidak Aktif' : 'Aktif' }}
                              </v-card>
                            </div>
                          </div>
                        </v-card>
                      </v-col>

                      <v-col
                        cols="12"
                        md="3">
                        <v-card
                          flat
                          color="#F9F9F9"
                          style="border: 1px solid #D8D8D8; border-radius: 10px;">
                          <div
                            class="d-flex align-center">
                            <div
                              style="border-right: 1px solid #D8D8D8; width: 40%;">
                              <v-card
                                flat
                                color="#EDEDED"
                                class="body-2 font-weight-bold pa-4"
                                style="opacity: 70%;">
                                Nama PIC
                              </v-card>

                              <v-divider
                                style="border-top: 1px solid #D8D8D8;"/>

                              <v-card
                                flat
                                color="#EDEDED"
                                class="body-2 font-weight-bold pa-4"
                                style="opacity: 70%;">
                                Email PIC
                              </v-card>
                            </div>

                            <div
                              style="width: 60%;">
                              <v-card
                                flat
                                color="transparent"
                                class="body-2 pa-4 text-truncate"
                                style="opacity: 70%;">
                                {{ detail.pic_user_fullname }}
                              </v-card>

                              <v-divider
                                style="border-top: 1px solid #D8D8D8;"/>

                              <v-card
                                flat
                                color="transparent"
                                class="body-2 pa-4 text-truncate"
                                style="opacity: 70%;">
                                {{ detail.pic_user_email }}
                              </v-card>
                            </div>
                          </div>
                        </v-card>
                      </v-col>

                      <v-col
                        cols="12"
                        md="3">
                        <v-card
                          flat
                          color="#F9F9F9"
                          style="border: 1px solid #D8D8D8; border-radius: 10px;">
                          <div
                            class="d-flex align-center">
                            <div
                              style="border-right: 1px solid #D8D8D8; width: 50%;">
                              <v-card
                                flat
                                color="#EDEDED"
                                class="body-2 font-weight-bold pa-4"
                                style="opacity: 70%;">
                                Quota
                              </v-card>

                              <v-divider
                              style="border-top: 1px solid #D8D8D8;"/>

                              <v-card
                                flat
                                color="#EDEDED"
                                class="body-2 font-weight-bold pa-4"
                                style="opacity: 70%;">
                                Quota Terpakai
                              </v-card>
                            </div>

                            <div
                              style="width: 50%;">
                              <v-card
                                flat
                                color="transparent"
                                class="body-2 pa-4"
                                style="opacity: 70%;">
                                {{ detail.user_quota }}
                              </v-card>

                              <v-divider
                              style="border-top: 1px solid #D8D8D8;"/>

                              <v-card
                                flat
                                color="transparent"
                                class="body-2 pa-4"
                                style="opacity: 70%;">
                                {{ detail.user_quota_used }}
                              </v-card>
                            </div>
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </section>

        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="diskominfo"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Layanan
                    </span>
                  </div>

                  <v-spacer />

                  <div>
                    <v-btn
                      @click="dialog.form = true; reset();"
                      color="#4B4B4B"
                      elevation="0"
                      class="body-2 white--text text-capitalize d-flex align-center"
                      style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                      <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                      
                      <span
                        class="ml-2">
                        Tambah Quota
                      </span>
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 py-0 pr-1">
            <v-col
              cols="8">
              <v-btn
                v-for="(item, index) in menu"
                :key="index"
                @click="selected.menu = index; fetch();"
                :color="selected.menu === index ? set_color : '#ededed'"
                :class="selected.menu === index ? 'white--text' : 'grey--text text--darken-1'"
                width="100"
                elevation="0"
                class="body-2 text-capitalize mr-4"
                style="border-radius: 10px; font-weight: 600;">
                {{ item }}
              </v-btn>
            </v-col>

            <v-col
              cols="4"
              class="d-flex align-center">
              <v-text-field
                @click:clear="search = ''; fetch();"
                v-on:keyup.enter="fetch()"

                filled
                rounded
                dense
                single-line

                hide-details
                :color="set_color"
                placeholder="Cari data yang Anda butuhkan . . ."
                append-icon="mdi-magnify"
                clearable

                v-model="search"
                style="border-radius: 10px;">
              </v-text-field>

              <!-- FREEZE COLUMN -->
              <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      elevation="0"
                      outlined
                      dark
                      min-width="36"
                      color="#7B7B7B"
                      class="text-capitalize px-0"
                      style="border-radius: 10px;"
                      v-bind="attrs"
                      v-on="on"
                      @click="dialog.freeze = true">
                      <v-icon size="18">mdi-table-split-cell</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Freeze
                  </span>
                </v-tooltip>
              </div>

              <!-- HIDE COLUMN -->
              <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      elevation="0"
                      outlined
                      dark
                      min-width="36"
                      color="#7B7B7B"
                      class="text-capitalize px-0"
                      style="border-radius: 10px;"
                      v-bind="attrs"
                      v-on="on"
                      @click="dialog.hide = true">
                      <v-icon size="18">mdi-eye-off-outline</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Hide
                  </span>
                </v-tooltip>
              </div>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-data-table
                  v-model="selected.row"
                  ref="table-grid"
                  class="table-grid"
                  :height="`calc(100vh - ${pagination.total_data > 0 ? '598px' : '516px'})`"
                  :show-select="checkbox"
                  :single-select="true"
                  :loading="process.load"
                  loading-text="Sedang memuat data . . ."
                  loader-height="5"
                  no-results-text="Belum ada data"
                  :options.sync="options"
                  :headers="configHeaders"
                  :items="list"
                  :items-per-page="100"
                  item-key="id"
                  @click:row="rowClick"
                  @toggle-select-all="handleToggleAll($event)"
                  @dblclick:row="doubleClick"
                  hide-default-footer>
                  <template
                    v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                    v-slot:[`item.${header.value}`]="{ value, index }">
                    <div
                      v-bind:key="header.value">
                      <div v-if="header.format !== 'regex' && header.format !== 'image' && header.format !== 'image_potrait' && header.format !== 'image_landscape' && header.format !== 'action' && header.format !== 'bool' && header.format !== 'status' && header.format !== 'link'">
                        {{ rowFormat(header.format, value) }} 
                      </div>

                      <div v-if="header.format === 'link'"
                        @click="fetchDetailInvoice(index)"
                        class="cursor-pointer">
                        <span
                          class="primary--text">
                          {{ value }}
                        </span>
                      </div>
        
                      <div v-if="header.format === 'regex'">
                        <span
                          class="two-line">
                          {{ rowFormat(header.format, value) }}
                        </span>
                      </div>
        
                      <div v-if="header.format === 'image'"
                        class="ma-4">
                        <v-avatar
                          size="60"
                          tile
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <v-img 
                            contain
                            width="100%"
                            height="100%"
                            alt="diskominfo" 
                            :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                            class="ma-auto">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="20"
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-avatar>
                      </div>

                      <div v-if="header.format === 'image_potrait'"
                        class="ma-4">
                        <v-img 
                          contain
                          width="100"
                          height="125"
                          alt="diskominfo" 
                          :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                          class="ma-auto"
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>

                      <div v-if="header.format === 'image_landscape'"
                        class="ma-4">
                        <v-img 
                          contain
                          width="200"
                          height="125"
                          alt="diskominfo" 
                          :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                          class="ma-auto"
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>

                      <div v-if="header.format === 'action'">
                        <v-btn
                          @click="dialog.form = true; reset(index);"
                          min-width="28"
                          small
                          rounded
                          :color="set_color"
                          elevation="0"
                          class="white--text text-capitalize mx-1 px-0"
                          style="font-weight: 600; border-radius: 6px;">
                          <v-icon small>mdi-google-circles-extended</v-icon>
                        </v-btn>
                      </div>

                      <div v-if="header.format === 'bool'"
                        class="d-flex align-center justify-center">
                        
                      </div>

                      <div v-if="header.format === 'status'"
                        class="d-flex justify-center">
                        <v-chip
                          small
                          rounded
                          :color="value === 'Belum Bayar' ? 'yellow' : 'green'"
                          elevation="0"
                          class="text-capitalize mx-1 d-flex justify-center"
                          :class="value === 'Belum Bayar' ? '' : 'white--text'"
                          style="font-weight: 600; width: 100px;">
                          {{ value }}
                        </v-chip>
                      </div>
                    </div>
                  </template>

                  <template v-slot:[`item.index`]="{ index }">
                    {{ lastIndex + index }}
                  </template>

                  <v-progress-linear 
                    v-show="process.load" 
                    slot="progress" 
                    color="white" 
                    indeterminate>
                  </v-progress-linear>
                </v-data-table>

                <pagination v-if="pagination.total_data > 0"
                  @changePage="fetch($event)" 
                  @reloadPage="fetch($event)" 
                  :model="pagination"/>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,

        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          form: false,
          detail: false
        },

        search: '',

        autocomplete: {
          package: ''
        },

        menu: ['Invoice', 'Quota'],

        selected: {
          row: [],
          freeze: [],

          menu: 0
        },

        packages: [],

        detail: {},
        detail_invoice: {},
        options: {},
        headers: [],
        list: [],
        pagination: {},

        lastIndex: 0,
        limit: 20,

        form: {
          package_id: '',
          company_id: '',
          quota: 10,
          at_price: 0,
          price: 0,
          at_discount: 0,
          discount: 0,
          total: 0,

          month: 1,
          start_date: '',
          end_date: '',

          company_item_id: ''
        },

        index_extend: '',

        picker: {
          start: false,
          end: false
        },

        process: {
          load: false,
          form: false,

          package: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    watch: {
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          
          this.fetch(pagination)
        },
        deep: true
      },

      'autocomplete.package': function() {
        this.fetchPackage()
      },

      'form.package_id': function() {
        let self = this
        let data = this.packages.filter(function(v) {
          return self.form.package_id == v.id
        })

        if (data.length > 0) {
          this.form.at_price = parseInt(data[0].price)
          this.form.at_discount = parseInt(data[0].discount)

          let total = (parseInt(this.form.quota) * parseInt(this.form.at_price)) - (parseInt(this.form.quota) * parseInt(this.form.at_discount))
        
          this.form.price = (parseInt(this.form.quota) * parseInt(this.form.at_price))
          this.form.discount = (parseInt(this.form.quota) * parseInt(this.form.at_discount))

          this.form.total = total > 0 ? total : 0
        }
      },

      'form.quota': function() {
        this.form.price = (parseInt(this.form.quota) * parseInt(this.form.at_price))
        this.form.discount = (parseInt(this.form.quota) * parseInt(this.form.at_discount))

        this.form.total = (parseInt(this.form.quota) * parseInt(this.form.at_price)) - (parseInt(this.form.quota) * parseInt(this.form.at_discount))
      },

      'form.month': function() {
        this.form.end_date = moment(this.form.start_date, 'YYYY-MM-DD').add(parseInt(this.form.month) * 29, 'days').format('YYYY-MM-DD')
      },

      'form.start_date': function(val) {
        if (val !== '' && val !== null) {
          this.form.end_date = moment(val, 'YYYY-MM-DD').add(parseInt(this.form.month) * 29, 'days').format('YYYY-MM-DD')
        } else {
          this.form.end_date = ''
        }
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        let params = {
          id: this.$route.params.id
        }

        await get(`internal/company/detail`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.detail = res.results.data
          }
        })
      },

      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = parseInt(value) + '%'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },

      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search,

          company_id: this.$route.params.id
        }

        this.selected.row = []

        let url = this.selected.menu < 1 ? 'internal/invoice/data' : 'internal/service/data'

        await get(url, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          this.list = []
          this.pagination = {}
            
          if (res.status === 200) {
            this.headers = this.selected.menu < 1 ? [
              {
                text: 'No. Invoice',
                width: '200px',
                value: 'code',
                freeze: true,
                hide: false,
                format: 'link'
              },
              {
                text: 'Status',
                width: '150px',
                value: 'status',
                freeze: false,
                hide: false,
                align: 'center',
                format: 'status'
              },
              {
                text: 'Nama Perusahaan',
                width: '300px',
                value: 'company_name',
                freeze: false,
                hide: false
              },
              {
                text: 'Paket',
                width: '200px',
                value: 'package_name',
                freeze: false,
                hide: false
              },
              {
                text: 'Quota',
                width: '200px',
                value: 'quota',
                freeze: false,
                hide: false,
                align: 'center'
              },
              // {
              //   text: 'Quota Terpakai',
              //   width: '200px',
              //   value: 'quota_used',
              //   freeze: false,
              //   hide: false,
              //   align: 'center'
              // },
              {
                text: 'Harga',
                width: '200px',
                value: 'price',
                freeze: false,
                hide: false,
                align: 'end',
                format: 'number'
              },
              {
                text: 'Diskon',
                width: '200px',
                value: 'discount',
                freeze: false,
                hide: false,
                align: 'end',
                format: 'number'
              },
              {
                text: 'Total',
                width: '200px',
                value: 'total',
                freeze: false,
                hide: false,
                align: 'end',
                format: 'number'
              },
              {
                text: 'Mulai Tanggal',
                width: '200px',
                value: 'start_date',
                freeze: false,
                hide: false,
                format: 'date'
              },
              {
                text: 'Berakhir Tanggal',
                width: '200px',
                value: 'end_date',
                freeze: false,
                hide: false,
                format: 'date'
              },
              {
                text: 'Jatuh Tempo Tanggal',
                width: '200px',
                value: 'due_date',
                freeze: false,
                hide: false,
                format: 'date'
              },
              {
                text: 'Masa Tenggang Tanggal',
                width: '200px',
                value: 'time_limit_date',
                freeze: false,
                hide: false,
                format: 'date'
              },
              {
                text: 'Dibuat Oleh',
                width: '200px',
                value: 'input_admin_name',
                freeze: false,
                hide: false
              },
              {
                text: 'Dibuat Tanggal',
                width: '200px',
                value: 'input_datetime',
                freeze: false,
                hide: false,
                format: 'datetime'
              }
            ] : [
              {
                text: 'Aksi',
                width: '110px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'center',
                format: 'action'
              },
              {
                text: 'Kode',
                width: '200px',
                value: 'code',
                freeze: true,
                hide: false
              },
              {
                text: 'Quota',
                width: '200px',
                value: 'quota',
                freeze: false,
                hide: false,
                align: 'center'
              },
              {
                text: 'Quota Terpakai',
                width: '200px',
                value: 'quota_used',
                freeze: false,
                hide: false,
                align: 'center'
              },
              {
                text: 'Mulai Tanggal',
                width: '200px',
                value: 'start_date',
                freeze: false,
                hide: false,
                format: 'date'
              },
              {
                text: 'Berakhir Tanggal',
                width: '200px',
                value: 'end_date',
                freeze: false,
                hide: false,
                format: 'date'
              }
            ]

            this.list = res.results.data
            this.pagination = res.results.pagination

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },

      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()

        this.form = {
          package_id: '',
          company_id: this.$route.params.id,
          quota: index !== undefined ? parseInt(this.list[index].quota) : 10,
          at_price: 0,
          price: 0,
          at_discount: 0,
          discount: 0,
          total: 0,

          month: 1,
          start_date: index !== undefined ? this.list[index].end_date : '',
          end_date: '',

          company_item_id: index !== undefined ? this.list[index].id : ''
        }

        this.index_extend = index !== undefined ? index : ''

        this.picker = {
          start: false,
          end: false
        }

        this.process.form = false

        this.message.error = ''
      },

      async fetchPackage () {
        this.process.package = true

        let params = {
          search: this.autocomplete.package
        }

        await get(`public/package/data`, { params })
        .then(response => {
          let res = response.data

          this.process.package = false
            
          if (res.status === 200) {
            this.packages = res.results.data
          }
        })
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          let url = this.index_extend === '' ? 'internal/service/add_quota' : 'internal/service/extend_quota'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.index_extend = ''

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      async fetchDetailInvoice (index) {
        let params = {
          id: this.list[index].id
        }

        await get(`internal/invoice/detail`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.detail_invoice = res.results.data

            this.dialog.detail = true
          }
        })
      },
      async save_approved () {
        this.message.error = ''

        this.process.form = true

        // SAVE TO REST API
        await post(`internal/invoice/payment`, {
          data: {
            id: this.selected.row[0].id
          }
        })
        .then((response) => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {
            this.dialog.detail = false

            this.dialog.snackbar = true
            this.message.success = res.message

            this.selected.menu = 1

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>